import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import ServicesGrid from './ServicesGrid';

const StorefrontProviderServices = () => {
  return /*#__PURE__*/_jsxs(UIGrid, {
    className: "align-center",
    children: [/*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        sm: 12,
        md: 12,
        lg: 5,
        xl: 5
      },
      children: [/*#__PURE__*/_jsx(H2, {
        className: "is--heading-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.storefront.providerServices.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.storefront.providerServices.subtitle"
        })
      })]
    }), /*#__PURE__*/_jsx(UIGridItem, {
      size: {
        sm: 12,
        md: 12,
        lg: 6,
        xl: 6
      },
      offset: {
        sm: 0,
        md: 0,
        lg: 1,
        xl: 1
      },
      children: /*#__PURE__*/_jsx(ServicesGrid, {})
    })]
  });
};

export default StorefrontProviderServices;